import type { ContentsFilterInputType } from "@/types/graphql/partner.generated";

/**
 * Значения фильтра из querystring в `filter` списка стримов, без `type`: его
 * добавляет список (`ContentTypeType.StreamType`), а в отчёте реестр.
 */
export function buildStreamsFilter(
  filter: Record<string, unknown>
): ContentsFilterInputType {
  return {
    search: filter.search as string | undefined,
    productIds: filter.productIds as string[] | undefined,
  };
}
